module.exports = __webpack_public_path__ + "static/media/nav_more.0d5c3488.svg";